import requestpApi, { requestApi } from "../../common/boxp_api_client";
import { BASE_API_URL_BOXP, BASE_API_URL_BOXR } from "lib/constants";
import requestrApi from "../../common/boxr_api_client";

const getCustomerAll = (params) => {
  return requestpApi({
    url: `${BASE_API_URL_BOXP}/customer`,
    method: "GET",
    params,
  });
};
const approvalList = (params) => {
  return requestpApi({
    url: `${BASE_API_URL_BOXP}/mro_approvals_list`,
    method: "GET",
    params
  });
};

const updateStatus = (data) => {
  return requestrApi({
    url: "/release_types/map_organisation",
    method: "PUT",
    data,
  });
};

const updateApprovalNumber = (formData) => {
  return requestApi({
    url: `${BASE_API_URL_BOXR}/release_types/edit_release_type`,
    method: "PUT",
    data: formData,
  });
};
const createPartsList = (formData) => {
  return requestpApi({
    url: `${BASE_API_URL_BOXP}/add_parts_markup_band`,
    method: "POST",
    data: formData,
  });
};
const updatePartsList = (formData) => {
  return requestpApi({
    url: `${BASE_API_URL_BOXP}/update_parts_markup_band?_method=PUT`,
    method: "POST",
    data: formData,
  });
};
function deletePartsmarkData(params) {
  return requestpApi({
    url: `/delete_parts_markup_band`,
    method: 'DELETE',
    params
  })
}

const getAllPartsMarkup = (params) => {
  return requestpApi({
    url: `/get_all_parts_markup_band`,
    method: "GET",
    params,
  });
};
const getAllApprovalManHours = (params) => {
  return requestpApi({
    url: `/get_all_approval_type_man_hours`,
    method: "GET",
    params,
  });
};

const createApprovalManHours = (formData) => {
  return requestpApi({
    url: `${BASE_API_URL_BOXP}/add_approval_type_man_hours`,
    method: "POST",
    data: formData,
  });
};
const updateManHours = (formData) => {
  return requestpApi({
    url: `${BASE_API_URL_BOXP}/update_approval_type_man_hours?_method=PUT`,
    method: "POST",
    data: formData,
  });
};

function deleteApprovalManHours(params) {
  return requestpApi({
    url: `/delete_approval_type_man_hours`,
    method: 'DELETE',
    params
  })
}

const workshopCustomerClient = {
  getCustomerAll,
  updateStatus,
  approvalList,
  updateApprovalNumber,
  updatePartsList,
  createPartsList,
  deletePartsmarkData,
  getAllPartsMarkup,
  getAllApprovalManHours,
  createApprovalManHours,
  updateManHours,
  deleteApprovalManHours
};

export default workshopCustomerClient;
